"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapData = void 0;
const get_component_from_item_by_id_1 = require("./components/get-component-from-item-by-id");
const get_component_values_1 = require("./components/get-component-values");
const map_accessory_1 = require("./map-accessory");
const map_interior_1 = require("./map-interior");
const map_package_equipment_1 = require("./map-package-equipment");
const map_pricing_1 = require("./map-pricing");
const map_tire_set_1 = require("./map-tire-set");
const map_varnish_1 = require("./map-varnish");
const map_vehicle_model_1 = require("./map-vehicle-model");
const enums_1 = require("../../../enums");
const legacy_mappers_1 = require("./legacy-mappers");
// @ts-ignore
const lodash_1 = require("lodash");
const mapData = (data) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, lodash_1.compact)(Object.values(data !== null && data !== void 0 ? data : {}).map((salesPackage) => {
        var _a;
        try {
            // Crystallize
            const { priceVariants, sku, images } = salesPackage === null || salesPackage === void 0 ? void 0 : salesPackage.defaultVariant;
            const price = (0, get_component_values_1.getPriceVariant)(priceVariants, 'default');
            const standardRimCode = (0, get_component_values_1.getSingleLineComponentValue)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'standardRimCode'));
            const wheelSetChunks = (0, get_component_values_1.getContentChunks)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'wheels'));
            const accessoryChunks = (0, get_component_values_1.getContentChunks)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'accessories'));
            const varnishChunks = (0, get_component_values_1.getContentChunks)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'varnishes'));
            const interiorChunks = (0, get_component_values_1.getContentChunks)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'interiors'));
            // BOS
            const vehicleModel = (0, map_vehicle_model_1.mapVehicleModel)(salesPackage);
            const pricing = (0, map_pricing_1.mapVehicleConfigurationPricing)(salesPackage);
            const packageEquipment = (0, map_package_equipment_1.mapPackageEquipment)(salesPackage);
            const isElectric = ((_a = vehicleModel === null || vehicleModel === void 0 ? void 0 : vehicleModel.fuel) === null || _a === void 0 ? void 0 : _a.type) === enums_1.VehicleFuelType.ELECTRIC;
            const accessories = (0, lodash_1.compact)(accessoryChunks === null || accessoryChunks === void 0 ? void 0 : accessoryChunks.flatMap((chunk) => (0, map_accessory_1.mapAccessory)(chunk, isElectric)));
            const interiors = (0, lodash_1.compact)(interiorChunks === null || interiorChunks === void 0 ? void 0 : interiorChunks.flatMap((chunk) => (0, map_interior_1.mapInterior)(chunk)));
            const varnishes = (0, lodash_1.compact)(varnishChunks === null || varnishChunks === void 0 ? void 0 : varnishChunks.flatMap((chunk) => (0, map_varnish_1.mapVarnish)(chunk)));
            const tires = (0, lodash_1.compact)(wheelSetChunks === null || wheelSetChunks === void 0 ? void 0 : wheelSetChunks.flatMap((chunk) => (0, map_tire_set_1.mapTireSet)(chunk, isElectric)));
            const vehicleConfiguration = {
                id: salesPackage.id,
                name: salesPackage.name,
                price,
                priceExcludingVat: price,
                sku,
                images: (0, legacy_mappers_1.mapImages)(images),
                accessories,
                electricProps: {
                    extraEffect: vehicleModel.effect,
                    extraElectricRange: vehicleModel.electricProps.electricRange,
                    extraBatteryCapacity: vehicleModel.electricProps.batteryCapacity,
                },
                interiors,
                model: vehicleModel,
                optionPackages: [],
                pricing,
                rims: standardRimCode !== null && standardRimCode !== void 0 ? standardRimCode : null,
                salesPackages: [packageEquipment],
                tires,
                varnishes,
            };
            return vehicleConfiguration;
        }
        catch (_b) {
            // Mapping failures due to faulty PIM data should fail gracefully.
            // This will be hidden by `lodash.compact`, which in practice hides
            // the vehicle from the results.
            return null;
        }
    }));
});
exports.mapData = mapData;
//# sourceMappingURL=map-data.js.map